<zs-progress-bar
  class="zs-progress-bar {{modeClass}}" max={{max}} value={{value}}
  label={{label}} animate={{animate}} duration={{duration}} metrics={{metrics}}
  norender={{norender}}>
</zs-progress-bar>
